<script setup>
import { useModal } from '@/composables/useModal.js';
import Modal from '@/components/Modal.vue';
import AppButton from '@/components/AppButton.vue';
import { useForm } from '@inertiajs/vue3';
import { IconTrash } from '@tabler/icons-vue';

const { isOpen } = useModal(false);
const props = defineProps({
    links: {
        type: Object,
        required: true,
    },
});

const form = useForm({});

const formBatch = useForm({});

const deleteMessage = () => {
    form.delete(props.links.delete, {
        preserveScroll: true,
        onSuccess: () => {
            dismiss();
        },
    })
};

const deleteBatchMessage = () => {
    formBatch.delete(props.links.delete_batch, {
        preserveScroll: true,
        onSuccess: () => {
            dismiss();
        },
    })
};

const dismiss = () => {
    isOpen.value = false;
};

</script>
<script>
export default {
    name: 'DeleteMessageModal',
};
</script>
<template>
    <button type="button" @click="isOpen = !isOpen">
        <IconTrash class="text-gray-700 pr-1 h-6 w-6" />

        <Modal :show="isOpen" @close="isOpen = false">
            <div>
                {{ $t('messages.delete_message_warning') }}
            </div>
            <div class="flex justify-end gap-2 items-center my-1 flex-wrap">
                <form @submit.prevent="deleteMessage()"  v-if="links.delete">
                    <AppButton
                        element="button"
                        type="submit"
                        :processing="form.processing"
                        desired-action="danger"
                    >
                        {{ $t('messages.delete_message_button') }}
                    </AppButton>
                </form>
                <form @submit.prevent="deleteBatchMessage()"  v-if="links.delete_batch">
                    <AppButton
                        element="button"
                        type="submit"
                        :processing="formBatch.processing"
                        desired-action="danger"
                    >
                        {{ $t('messages.delete_batch_message_button') }}
                    </AppButton>
                </form>
                <AppButton element="button" type="button" @click="dismiss()">
                    {{ $t('messages.cancel') }}
                </AppButton>
            </div>
        </Modal>
    </button>
</template>
